import React from 'react';
import SimpleSearchSelect from '../Forms/Input/SimpleSearchSelect';
import SvgIcon from '../SvgIcon/SvgIcon';
import FileUploader from '../Uploader/FileUploader';

interface ImportFormProps {
  availableImportTypes: {
    id: number;
    name: string;
    code: string;
  }[];
  selectedImportTypeId: number | null;
  onImportTypeChange: (id: number | null) => void;
  onFileChange: (file: File | null) => void;
  onImport: () => void;
  onReset: () => void;
  loading?: boolean;
  error?: string;
  successMessage?: string;
  currentFile?: File | null;
  onClearState?: () => void; // ✅ NUEVO props opcional para limpiar estado global
}

const ImportForm: React.FC<ImportFormProps> = ({
  availableImportTypes,
  selectedImportTypeId,
  onImportTypeChange,
  onFileChange,
  onImport,
  onReset,
  loading = false,
  error,
  successMessage,
  currentFile,
  onClearState, // ✅ lo recibimos aquí también
}) => {
  return (
    <div className="px-6 pb-6 pt-6">
      {/* Selector de tipo de importación */}
      <div className="mb-6 flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
        <div className="w-full sm:w-1/2 md:w-1/3">
          <SimpleSearchSelect
            label="Tipo de Importación"
            name="importType"
            options={availableImportTypes.map((type) => ({
              id: type.id,
              name: type.name,
            }))}
            selectedValue={selectedImportTypeId}
            onSelect={(selected) => {
              onImportTypeChange(selected ? selected.id : null);
              onFileChange(null); // Limpia el archivo local
              onClearState?.();   // Limpia el estado global si se envió
            }}
            searchPlaceholder="Buscar tipo de importación..."
            iconKey="list"
          />
        </div>

        <div className="flex w-full flex-wrap justify-end gap-2 sm:w-auto sm:justify-start">
          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center gap-2 rounded bg-[#DC3545] px-5 py-2.5 text-sm font-medium text-white hover:bg-opacity-90"
          >
            <SvgIcon name="cancel" />
            Restablecer
          </button>

          <button
            type="button"
            disabled={!selectedImportTypeId || !currentFile || loading}
            onClick={onImport}
            className="inline-flex items-center gap-2 rounded bg-primary px-5 py-2.5 text-sm font-medium text-white hover:bg-opacity-90 disabled:opacity-50"
          >
            <SvgIcon name="upload" />
            {loading ? 'Importando...' : 'Importar Archivo'}
          </button>
        </div>
      </div>

      {/* Input de archivo */}
      {selectedImportTypeId && (
        <FileUploader
          currentFile={currentFile}
          onFileChange={onFileChange}
          onRemoveFile={() => {
            onFileChange(null);
            onClearState?.(); // ✅ Se limpia también el estado global
          }}
          onClearState={onClearState} // ✅ También por si FileUploader lo requiere directamente
          label="Seleccione un archivo Excel"
          accept=".xlsx,.xls"
          iconKey="upload"
        />
      )}

      {/* Mensajes */}
      {error && (
        <div className="text-red-600 dark:text-red-400 mt-2 text-sm">
          ❌ {error}
        </div>
      )}
      {successMessage && (
        <div className="mt-2 text-sm text-green-600 dark:text-green-400">
          ✅ {successMessage}
        </div>
      )}
    </div>
  );
};

export default ImportForm;
